export default "assets/images/icons/pin-6facfe41.svg";